export default __webpack_public_path__ + "static/media/icon-prop-add.70c689b4.svg";